module.exports = __webpack_public_path__ + "static/the-stranger-69d34bf8a292e92b688b2939bc6d6823.jpg";